import * as React from 'react';
import { OffersCountLink } from '../OffersCountLink';

import * as styles from './styles.css';
import { IPromoInfo } from '../../../../types/newbuilding/promoInfo';

interface IRowsExpanderProps {
  error: JSX.Element;
  content: (promo: IPromoInfo[]) => JSX.Element;
  promos: IPromoInfo[];
  onDisplayedOffersChange: (promo: IPromoInfo[]) => void;
}

const VISIBLE_ROWS_COUNT = 5;

export const RowCountController: React.VFC<IRowsExpanderProps> = ({
  content,
  error,
  onDisplayedOffersChange,
  promos,
}) => {
  const [expanded, setExpanded] = React.useState(false);

  const displayedPromos = expanded ? promos : promos.slice(0, VISIBLE_ROWS_COUNT);
  const unvisibleRowsCount = promos.length - VISIBLE_ROWS_COUNT;
  const isCountLinkVisible = promos.length > VISIBLE_ROWS_COUNT;

  React.useEffect(() => {
    onDisplayedOffersChange(displayedPromos);
  }, [displayedPromos]);

  if (displayedPromos.length === 0) {
    return error;
  }

  return (
    <div className={styles.container}>
      {content(displayedPromos)}
      {isCountLinkVisible && (
        <OffersCountLink expanded={expanded} count={unvisibleRowsCount} onClick={() => setExpanded(!expanded)} />
      )}
    </div>
  );
};
